
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.16 3.804A1 1 0 0021.18 3H5.45a1 1 0 00-.748.336l-3.45 3.88A1 1 0 001 7.88v2.706a1 1 0 00.293.707l.414.414a1 1 0 00.707.293h1.162c.248 0 .424.251.424.5a1.5 1.5 0 003 0c0-.249.176-.5.424-.5h9.152c.248 0 .424.251.424.5a1.5 1.5 0 003 0c0-.249.176-.5.424-.5H22a1 1 0 001-1V8.099c0-.066-.006-.132-.02-.196l-.82-4.1zM3.684 6.18l1.667-2A.5.5 0 015.734 4H9.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H4.068a.5.5 0 01-.385-.82zM11 5.5v-1a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5zm6.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zM19 4.5v1a.5.5 0 00.5.5h1.36a.5.5 0 00.485-.621l-.25-1A.5.5 0 0020.61 4H19.5a.5.5 0 00-.5.5z","fill":"currentColor"}})])
          )
        }
      }
    